import { ECampaignType } from "@/modules/helpers/enum"

export const Colors = {
  white: "white",
  borderColor: "#EBEBEB",
  success: "#4CAF50",
  primary: "#8409FF",
  primary_20: "rgba(132, 9, 255, 0.1)",
  black: "#000000",
  pink: {
    4: "#FC3AA6"
  },
  green: {
    8: "#E0FBE2"
  },
  accent: {
    1: "#FFCD03"
  },
  orange: {
    3: "#FB8A4B"
  },
  grey: {
    3: "#A8A8A8",
    1: "#474747",
    4: "#EBEBEB"
  },
  error: {
    1: "#FF7070"
  },
  gray: {
    1: "#f3f4f6"
  },
  gray_20: "#F5F5F590",
  text: "#474747"
}

export const COLORS_BY_CAMPAIGN_TYPE = {
  [ECampaignType.COST_PER_VIEW]: {
    background: Colors.green[8],
    icon: Colors.success,
    text: Colors.success
  },
  [ECampaignType.REVIEW_PRODUCT]: {
    background: Colors.primary_20,
    icon: Colors.primary,
    text: Colors.primary
  },
  [ECampaignType.AFFILIATE]: {
    background: "#FFF1CC",
    icon: "#EA580C",
    text: "#EA580C"
  },
  accent: {
    1: "#FFCD03"
  },
  orange: {
    3: "#FB8A4B"
  },
  grey: {
    3: "#A8A8A8",
    1: "#474747",
    4: "#EBEBEB"
  },
  error: {
    1: "#FF7070"
  },
  gray: {
    1: "#f3f4f6"
  },
  gray_20: "#F5F5F590",
  text: "#474747"
}
